import type { ValidIconName } from '../../basic';
import { Icon, PersonImage } from '../../basic';
import React from 'react';
import { intl } from '../../../lib';
import type { UserState } from '../chatTypes';

type StatusProps = {
  state?: UserState;
  userStatusId: string;
};
const Status = ({ state, userStatusId }: StatusProps) => {
  if (state) {
    let ariaLabel;
    let iconName: ValidIconName = 'cancel';
    switch (state) {
      case 'online':
        ariaLabel = intl('common.userOnline');
        iconName = 'ok';
        break;
      case 'unavailable':
        ariaLabel = intl('common.userUnavailable');
        iconName = 'clock';
        break;
      case 'offline':
        ariaLabel = intl('common.userOffline');
        break;
      default:
        ariaLabel = '';
    }
    return (
      <output
        className={['badge', state].join(' ')}
        aria-label={ariaLabel}
        id={userStatusId}
      >
        <Icon iconName={iconName} aria-label={undefined} />
      </output>
    );
  } else return <></>;
};

export type ChatPersonImageProps = {
  firstname?: string;
  lastname?: string;
  avatar: 'group' | 'user';
  userStatus?: UserState;
  image?: string;
  userStatusId?: string;
};
export const ChatPersonImage = ({
  firstname,
  lastname,
  avatar,
  userStatus,
  image,
  userStatusId
}: ChatPersonImageProps) => {
  return (
    <div className="ehs-chat-person-image">
      <PersonImage
        emptyState={avatar === 'group' ? 'user-group' : 'user-3'}
        firstName={firstname}
        lastName={lastname}
        scale="small"
        image={image}
      />
      {userStatus && (
        <Status state={userStatus} userStatusId={userStatusId ?? ''} />
      )}
    </div>
  );
};
